// extracted by mini-css-extract-plugin
export var auto = "_4k-1";
export var spinner = "_4k-0";